import { AppLink } from './AppLink';
import { Icon } from './Icon';

type Props = {
  /** [label, path] pairs after Home. The last item is the current page (not linked). */
  trail: Array<[label: string, path: string]>;
  tone?: 'light' | 'dark';
  className?: string;
};

/** Visible breadcrumb trail. Pair it with breadcrumbLd(trail) in the page's <Seo jsonLd>. */
export function Breadcrumbs({ trail, tone = 'light', className = '' }: Props) {
  const items: Array<[string, string]> = [['Home', '/'], ...trail];
  const base = tone === 'dark' ? 'text-surface-ivory/60' : 'text-on-surface-variant';
  const current = tone === 'dark' ? 'text-gold-light' : 'text-primary';
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className={`flex flex-wrap items-center gap-1.5 font-label-sm text-label-sm uppercase tracking-widest ${base}`}>
        {items.map(([label, path], i) => {
          const last = i === items.length - 1;
          return (
            <li key={path} className="flex items-center gap-1.5">
              {last ? (
                <span aria-current="page" className={current}>
                  {label}
                </span>
              ) : (
                <>
                  <AppLink href={path} className="hover:text-secondary transition-colors">
                    {label}
                  </AppLink>
                  <Icon name="east" size={12} className="opacity-60" />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
